"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StepText = exports.StepButton = exports.Root = exports.NavigationBar = exports.Header = void 0;
var _components = require("@ori-ui/components");
var _mui = require("@ori-ui/mui");
var _models = require("../../models");
const getGridTemplateColumns = selectedStep => {
  if (selectedStep === _models.ShoppingStep.Offers) {
    return 'auto minmax(min-content, auto) auto';
  }
  if (selectedStep === _models.ShoppingStep.Checkout) {
    return 'auto auto minmax(min-content, auto)';
  }
  return 'minmax(min-content, auto) auto auto';
};
const Root = exports.Root = (0, _mui.styled)('div')(({
  theme
}) => ({
  gridArea: 'navigation',
  padding: theme.spacing(0, 3),
  [theme.breakpoints.up('sm')]: {
    padding: theme.spacing(0, 6)
  }
}));
const NavigationBar = exports.NavigationBar = (0, _mui.styled)('div')(({
  ownerState: {
    selectedStep
  },
  theme
}) => ({
  display: 'inline-grid',
  gridTemplateColumns: getGridTemplateColumns(selectedStep),
  gap: theme.spacing(3),
  justifyContent: 'start'
}));
const StepButton = exports.StepButton = (0, _mui.styled)(_components.Button)(({
  ownerState: {
    isSelected
  },
  theme
}) => ({
  textTransform: 'none',
  padding: 0,
  minWidth: 32,
  color: isSelected ? theme.palette.text.primary : theme.palette.grey[500],
  [`&.${_components.buttonClasses.focusVisible}`]: {
    color: theme.palette.text.primary
  },
  [`&.${_components.buttonClasses.disabled}`]: {
    color: theme.palette.grey[500]
  },
  '&:hover': {
    backgroundColor: 'unset',
    color: theme.palette.text.primary
  }
}));
const StepText = exports.StepText = (0, _mui.styled)(_mui.Typography)({
  textOverflow: 'ellipsis',
  overflow: 'hidden',
  whiteSpace: 'nowrap',
  fontWeight: 'bold'
});
const Header = exports.Header = (0, _mui.styled)(_mui.Typography)(({
  theme
}) => ({
  textAlign: 'start',
  margin: theme.spacing(6, 0),
  [theme.breakpoints.up('md')]: {
    textAlign: 'center',
    margin: theme.spacing(3, 0, 12, 0)
  }
}));